import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'wilson-pref-score',
  templateUrl: './pref-score.component.html',
  styleUrls: ['./pref-score.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PrefScoreComponent {
  @Input() prefScore!: number;
}
